var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),(_vm.$store.state.toast.showToast)?_c('toast'):_vm._e(),(_vm.$store.state.loader.showLoader)?_c('loader'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }